export default "__VITE_ASSET__DDT$UBiP__"